/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from 'react';
import { DataTable, DataTableFilterMeta, DataTableSelectionSingleChangeEvent } from 'primereact/datatable';
import { Column, ColumnEditorOptions } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Panel } from 'primereact/panel';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import Braid from '../../models/Braid';
import BraidSequence from '../../models/BraidSequence';
import { BraidService } from '../../service/BraidService';
import { Button } from 'primereact/button';
import { Controller, useForm } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from "primereact/checkbox";
import { Divider } from 'primereact/divider';
import RawMaterialGroup from '../../models/RawMaterialGroup';
import { RawMaterialGroupService } from '../../service/RawMaterialGroupService';
import { Link, useParams } from 'react-router-dom';
import { FilterMatchMode } from 'primereact/api';
import { Card } from 'primereact/card';

const BraidView = () => {
    let emptyBraid: Braid = {
        id: 0,
        stylename: '',
        width: 0,
        fabric_Code_Id: '',
        hasSequences: false
    };

    let emptyBraidSequence : BraidSequence = {
        id: 0,
        braid_Id: 0,
        sequence: '',
        quantity: 0,
        raw_Material_Group_Id: 0,
        raw_Material_Group: '',
        is_Color: true
    };

    const [braid, setBraid] = useState<Braid>(emptyBraid);
    const [braidSequences, setBraidSequences] = useState<BraidSequence[]>([]);
    const [loadingBraidSequences, setLoadingBraidSequences] = useState(true);
    const [braidSequence, setBraidSequence] = useState<BraidSequence>(emptyBraidSequence);
    const [deleteBraidSequenceDialog, setDeleteBraidSequenceDialog] = useState(false);
    const [globalFilter, setGlobalFilter] = useState<string>('');
    const [filters, setFilters] = useState<DataTableFilterMeta>({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    const [editingRows, setEditingRows] = useState({});
    const [rawMaterialGroups, setRawMaterialGroups] = useState<RawMaterialGroup[]>([]);
    const [rawMaterialGroupEditDescription, setRawMaterialGroupEditDescription] = useState<string | undefined>('');
    const [rawMaterialGroupDescription, setRawMaterialGroupDescription] = useState<string | undefined>('');
    const isNew = useRef(false);
    const toast = useRef<any>(null);
    const dtBraidSequences = useRef<any>(null)
    const { id } = useParams();
    
    useEffect(() => {
        if (!id) { return; }

        !loadingBraidSequences && setLoadingBraidSequences(true);

        BraidService.getBraid(Number(id)).then(data => setBraid(data));

        BraidService.getBraidSequences(Number(id)).then(data => {
            setBraidSequences(data);
            setLoadingBraidSequences(false);
        });  

        RawMaterialGroupService.getRawMaterialGroups().then(data => setRawMaterialGroups(data));
    }, []);

    const { 
        control: controlBraidSequence, 
        formState: { errors: errorsBraidSequence }, 
        clearErrors: clearErrorsBraidSequence,
        reset: resetBraidSequence,
        handleSubmit: handleSubmitBraidSequence } = useForm({ mode: "all" });

    const formEditBraidSequence = useForm({ mode: "all" });

    const onSubmitBraidSequence = (data: any) => {
        isNew.current = true;
        let _braidSequence = { ...braidSequence };
        _braidSequence.braid_Id = braid.id ?? 0;
        _braidSequence.sequence = String(data.sequence);
        _braidSequence.quantity = data.quantity;
        _braidSequence.raw_Material_Group_Id = data.raw_Material_Group_Id;
        _braidSequence.is_Color = data.is_Color;
        saveBraidSequence(_braidSequence);
    };

    const getBraidSequenceErrorMessage = (name: string) => {
        return errorsBraidSequence[name] ? <small className="p-error">{(errorsBraidSequence[name] as any).message}</small> : <small className="p-error">&nbsp;</small>;
    };

    const hideDeleteBraidSequenceDialog = () => {
        setDeleteBraidSequenceDialog(false);
    };

    const saveBraidSequence = (braidSequenceData: BraidSequence) => {
        let _braidSequences = [...braidSequences];
        if (isNew.current) {
            BraidService.addBraidSequence(braidSequenceData).then((data) => {
                if (data) {
                    _braidSequences.push(data);
                    setBraidSequences(_braidSequences);
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Braid Sequence Created', life: 3000 });
                    setBraidSequence(emptyBraidSequence);
                    _braidSequences.sort(function (a, b) { return (a.sequence < b.sequence) ? -1 : (a.sequence < b.sequence) ? 1 : 0; });
                    dtBraidSequences.current.props.value = _braidSequences;
                    resetBraidSequence();
                } else {
                    toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Create Braid Sequence', life: 3000 });
                }
            });
        } else {
            BraidService.updateBraidSequence(braidSequenceData).then((data) => {
                if (data) {
                    let braidSequenceIndex = braidSequences.findIndex(b => b.id === braidSequenceData.id);
                    _braidSequences[braidSequenceIndex] = braidSequenceData;
                    setBraidSequences(_braidSequences);
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Braid Sequence Updated', life: 3000 });
                } else {
                    toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Update Braid Sequence', life: 3000 });
                }
            });            
        }
    }

    const confirmDeleteBraidRawMaterialGroup = (braidSequence: BraidSequence) => {
        setBraidSequence(braidSequence);
        setDeleteBraidSequenceDialog(true);
    }

    const deleteBraidSequence = () => {
        BraidService.deleteBraidSequence(braidSequence.id).then((data) => {
            if (data) {
                let _braidSequences = braidSequences.filter(val => val.id !== braidSequence.id);
                setBraidSequences(_braidSequences);
                setDeleteBraidSequenceDialog(false);
                setBraidSequence(emptyBraidSequence);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Braid Sequence Deleted', life: 3000 });
            } else {
                toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Delete Braid Sequence', life: 3000 });
            }
        });
    }
   
    const onRowEditChange = (e: any) => {
        setEditingRows(e.data);
    }

    const setBraidSequenceRowIndex = (rowData: DataTableSelectionSingleChangeEvent<BraidSequence[]>) => {
        let selectedBraidSequenceIndex = braidSequences.findIndex(v => v.id === (rowData.value as BraidSequence).id);
        let _editingRows = { ...editingRows, ...{ [`${braidSequences[selectedBraidSequenceIndex].id}`]: true } };
        
        if(Object.keys(_editingRows).length === 1) {
            setEditingRows(_editingRows);
        }
    }

    const getRawMaterialGroupDescription = (id: number, isEdit: boolean) => {
        let _rawMaterialGroups = [ ...rawMaterialGroups ];
        let _rawMaterialGroupDescription = _rawMaterialGroups.find(v => v.id === id)?.description;
        setTimeout(() => isEdit ? setRawMaterialGroupEditDescription(_rawMaterialGroupDescription) : setRawMaterialGroupDescription(_rawMaterialGroupDescription), 0);
    };

    const sequenceEditor = (options: any) => {
        return (
            <Controller 
                name="sequenceEdit" 
                control={formEditBraidSequence.control} 
                defaultValue={options.value}
                rules={{
                    required: 'Sequence is required',
                    validate: {
                            unique: v => braidSequences.filter(val => val.sequence.localeCompare(v, 'en', {sensitivity: 'accent'}) === 0).length === 0 || 'Sequence must be unique.'
                    }
                }}
                render={({ field, fieldState }) => {
                    braidSequence.sequence = field.value;

                    return (
                        <>
                            <InputText value={fieldState.isDirty ? field.value : options.value} maxLength={15} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => {braidSequence.sequence = e.target.value; field.onChange(e.target.value);}} placeholder="Sequence" />
                        </>
                    )} 
                }
            />              
        );
    }

    const quantityEditor = (options: any) => {
        return (
            <Controller 
                name="quantityEdit" 
                control={formEditBraidSequence.control}
                defaultValue={options.value}
                render={({ field, fieldState }) => {
                    braidSequence.quantity = field.value;

                    return (
                        <>
                            <InputNumber id={field.name} name={field.name} inputRef={field.ref} value={fieldState.isDirty ? field.value : options.value} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} onBlur={field.onBlur} onValueChange={(e) => {braidSequence.quantity = (e.target.value as number); field.onChange(e);}} inputClassName={classNames({ 'p-invalid border-left-10': fieldState.error })} mode="decimal" useGrouping={false} maxFractionDigits={4} placeholder="Quantity" />
                        </>
                    )} 
                }
            />              
        );
    }

    const raw_Material_Group_Editor = (options: any) => {
        return (
            <Controller 
                name="raw_Material_Group_Edit" 
                control={formEditBraidSequence.control}
                defaultValue={options.value}
                rules = {{
                    required: 'Raw Material Group is required'
                }} 
                render={({ field, fieldState }) => {
                    braidSequence.raw_Material_Group_Id = field.value;
                    getRawMaterialGroupDescription(field.value === undefined ? options.value : field.value, true);

                    return (
                        <>
                            <Dropdown value={fieldState.isDirty ? field.value : options.value} options={rawMaterialGroups} optionLabel="raw_Material_Group" optionValue="id" tooltip={fieldState.invalid ? fieldState.error?.message : rawMaterialGroupEditDescription} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => {braidSequence.raw_Material_Group_Id = e.value; field.onChange(e.value);}} filter filterBy="raw_Material_Group_Id" placeholder="Raw Material Group" virtualScrollerOptions={{ itemSize: 50 }} />
                        </>
                    )} 
                }
            />              
        );
    }

    const is_Color_Editor = (options: any) => {
        return (
            <Controller 
                name="is_Color_Edit" 
                control={formEditBraidSequence.control}
                defaultValue={options.value}
                render={({ field, fieldState }) => {
                    braidSequence.is_Color = field.value;

                    return (
                        <>
                            <Checkbox inputId={field.name} checked={fieldState.isDirty ? field.value : options.value} inputRef={field.ref} className={classNames({ 'p-invalid mr-1': fieldState.error })} onChange={(e) => { braidSequence.is_Color = e.target.value; field.onChange(e.checked) }} />
                        </>
                    )}
                }
            />            
        );
    }

    const sequenceBodyTemplate = (rowData: BraidSequence) => {
        return rowData.sequence;
    }

    const quantityBodyTemplate = (rowData: BraidSequence) => {
        return rowData.quantity;
    }

    const raw_Material_Group_BodyTemplate = (rowData: BraidSequence) => {
        return rawMaterialGroups.find(item => item.id === rowData.raw_Material_Group_Id)?.raw_Material_Group;
    }

    const is_Color_BodyTemplate = (rowData: BraidSequence) => {
        if (rowData.is_Color) {
            return (
                <>
                    <i className="pi pi-check text-green-500"></i>
                </>
            );
        } else {
            return (
                <>
                    <i className="pi pi-times text-red-500"></i>
                </>
            );
        }
    }

    const rowEditorBraidSequenceTemplate = (rowData: BraidSequence, props: any) => {
        const rowEditor = props.rowEditor;

        if (rowEditor.editing) {
            isNew.current = false;

            return (
                <>
                    <Button icon="p-row-editor-save-icon pi pi-fw pi-save" title="Save" rounded text severity="info" type="submit" onClick={(e) => { 
                        if (!formEditBraidSequence.getFieldState("sequenceEdit").invalid && !formEditBraidSequence.getFieldState("quantityEdit").invalid && !formEditBraidSequence.getFieldState("raw_Material_Group_Edit").invalid && !formEditBraidSequence.getFieldState("is_Color_Edit").invalid) {
                            let _braidSequence = { ...braidSequence };
                            _braidSequence.id = rowData.id;
                            _braidSequence.braid_Id = rowData.braid_Id;
                            saveBraidSequence(_braidSequence);
                            formEditBraidSequence.clearErrors();
                            formEditBraidSequence.reset();
                            rowEditor.onSaveClick(e);
                        }
                    }} />
                    
                    <Button icon="p-row-editor-cancel-icon pi pi-fw pi-undo" title="Undo" rounded text severity="danger" onClick={(e) => {
                        formEditBraidSequence.clearErrors();
                        formEditBraidSequence.reset();
                        rowEditor.onCancelClick(e);
                    }} />
                </>
            );
        } else {
            return (
                <Link className="pi pi-fw pi-trash rowDelete" title="Delete" onClick={() => confirmDeleteBraidRawMaterialGroup(rowData)} to={''}></Link>
            );
        }
    }

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilter(value);
    };

    const headerBraidSequenceTable = (
        <div className="flex flex-column md:flex-row md:justify-content-end md:align-items-center">
            <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText className="p-inputtext-sm" type="search" autoComplete="off" value={globalFilter} onChange={onGlobalFilterChange} placeholder="Search..." />
            </IconField>
        </div>
    );

    const braidTitle = (
        <>
            <div className="flex flex-wrap gap-3 mt-2 mb-2">
                <div className="flex align-items-center">
                    <label className="ml-2 font-bold text-lg">Stripe Style:</label>
                    <label className="ml-2 text-primary font-bold text-lg">{braid.stylename}</label>
                </div>
                <div className="flex align-items-center">
                    <label className="ml-2 font-bold text-lg">Width:</label>
                    <label className="ml-2 text-primary font-bold text-lg">{braid.width}</label>
                </div>
                <div className="flex align-items-center">
                    <label className="ml-2 font-bold text-lg">Fabric:</label>
                    <label className="ml-2 text-primary font-bold text-lg">{braid.fabric_Code_Id}</label>
                </div>
            </div>
            
            <Divider />
        </>
    );

    const deleteBraidSequenceDialogFooter = (
        <>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteBraidSequenceDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteBraidSequence} />
        </>
    );

    return (
        <div className="grid-nogutter">
            <div className="col-12">
                <Toast ref={toast} />

                <Card className="layout-main-card border-noround" title={braidTitle}>
                    <Panel header="Add Braid Sequence" className="addPanel mb-2">
                        <form key={2} onSubmit={handleSubmitBraidSequence(onSubmitBraidSequence)} className="p-fluid" autoComplete="off">
                            <div className="formgrid grid">
                                <div className="field col-2">
                                    <Controller 
                                        name="sequence" 
                                        control={controlBraidSequence}
                                        defaultValue= {null}
                                        rules={{
                                            required: 'Sequence is required',
                                            validate: {
                                                unique: v => (braidSequences.length === 0 || braidSequences.filter(val => val.sequence.localeCompare(v, 'en', {sensitivity: 'accent'}) === 0).length === 0) || 'Sequence must be unique.'
                                            }
                                        }}
                                        render={({ field, fieldState }) => (
                                            <>
                                                <label htmlFor={field.name} className="font-bold text-xs">Sequence</label>
                                                <InputNumber id={field.name} name={field.name} inputRef={field.ref} value={field.value} onBlur={field.onBlur} onValueChange={(e) => field.onChange(e)} inputClassName={classNames({ 'p-invalid border-left-10': fieldState.error })} placeholder="Sequence" />
                                                {getBraidSequenceErrorMessage('sequence')}
                                            </>
                                        )}
                                    />
                                </div>
                                <div className="field col-2">
                                    <Controller 
                                        name="quantity" 
                                        defaultValue= {null}
                                        control={controlBraidSequence}
                                        render={({ field, fieldState }) => (
                                            <>
                                                <label htmlFor={field.name} className="font-bold text-xs">Quantity</label>
                                                <InputNumber id={field.name} name={field.name} inputRef={field.ref} value={field.value} onBlur={field.onBlur} onValueChange={(e) => field.onChange(e)} inputClassName={classNames({ 'p-invalid border-left-10': fieldState.error })} mode="decimal" useGrouping={false} maxFractionDigits={4} placeholder="Quantity" />
                                                {getBraidSequenceErrorMessage('quantity')}
                                            </>
                                        )}
                                    />                              
                                </div>
                                <div className="field col-2">
                                    <Controller 
                                        name="raw_Material_Group_Id" 
                                        control={controlBraidSequence} 
                                        defaultValue=""
                                        rules={{
                                            required: 'Raw Material Group is Required'
                                        }}
                                        render={({ field, fieldState }) => (
                                            <>
                                                <label htmlFor={field.name} className="font-bold text-xs">Raw Material Group</label>
                                                <Dropdown inputId={field.name} value={field.value} options={rawMaterialGroups} optionLabel="raw_Material_Group" optionValue="id" className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => {getRawMaterialGroupDescription(e.value, false); field.onChange(e.value);}} showClear filter filterBy="raw_Material_Group" placeholder="Raw Material Group" virtualScrollerOptions={{ itemSize: 50 }} />
                                                {(field.value !== null && field.value !== undefined && field.value !== '') ? <small className="text-primary">{rawMaterialGroupDescription}</small> : <></>}
                                                {getBraidSequenceErrorMessage('raw_Material_Group_Id')}
                                            </>
                                        )}
                                    />    
                                </div>
                                <div className="field col-fixed isCheckbox">
                                    <Controller
                                        name="is_Color"
                                        control={controlBraidSequence}
                                        render={({ field, fieldState }) => (
                                            <>
                                                <label htmlFor={field.name} className="font-bold text-xs">Is Color</label><br />
                                                <Checkbox inputId={field.name} checked={field.value} inputRef={field.ref} className={classNames('col-offset-3', { 'p-invalid mr-1': fieldState.error })} onChange={(e) => field.onChange(e.checked)} />
                                            </>
                                        )}
                                    />                                        
                                </div>
                                <div className="field field-buttons col-2 pt-4">
                                    <Button icon="pi pi-save" title="Save" rounded text severity="info" type="submit" />
                                    <Button icon="pi pi-undo" title="Undo" rounded text severity="danger" type="button" onClick={() => {resetBraidSequence(); clearErrorsBraidSequence();}} />
                                </div>
                            </div>
                        </form>
                    </Panel>
                    
                    <DataTable ref={dtBraidSequences} value={braidSequences} selectionMode="single" onSelectionChange={setBraidSequenceRowIndex}
                        dataKey="id" size="small" rowHover={true} loading={loadingBraidSequences}
                        sortField="color_Code"
                        scrollable scrollHeight="calc(100vh - 25rem)"
                        paginator alwaysShowPaginator={false} rows={25} rowsPerPageOptions={[5, 10, 25]} 
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} braid sequences."
                        editingRows={editingRows} editMode="row" onRowEditChange={onRowEditChange}
                        filters={filters} emptyMessage="No braid sequences found." header={headerBraidSequenceTable}>
                        <Column field="sequence" header="Sequence" body={sequenceBodyTemplate} editor={(options:ColumnEditorOptions) => sequenceEditor(options)} sortable align="center" alignHeader="center"></Column>
                        <Column field="quantity" header="Quantity" body={quantityBodyTemplate} editor={(options:ColumnEditorOptions) => quantityEditor(options)} sortable align="center" alignHeader="center"></Column>
                        <Column field="raw_Material_Group_Id" header="Raw Material Group" body={raw_Material_Group_BodyTemplate} editor={(options:ColumnEditorOptions) => raw_Material_Group_Editor(options)} sortable align="center" alignHeader="center"></Column>
                        <Column field="raw_Material_Group" header="Raw Material Group" style={{display: 'none'}}></Column>
                        <Column field="is_Color" header="Is_Color" body={is_Color_BodyTemplate} editor={(options:ColumnEditorOptions) => is_Color_Editor(options)} sortable align="center" alignHeader="center"></Column>
                        <Column rowEditor body={rowEditorBraidSequenceTemplate} headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
                    </DataTable>

                    <Dialog visible={deleteBraidSequenceDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteBraidSequenceDialogFooter} onHide={hideDeleteBraidSequenceDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {braidSequence && <span>Are you sure you want to delete Sequence <b>{braidSequence.sequence}</b>?</span>}
                        </div>
                    </Dialog>
                </Card>
            </div>
        </div>
    );
  }

export default BraidView;